/* Classic — scroll reveal orquestrado (progressive enhancement).
   Se JS falhar, conteúdo aparece normal (nada é escondido sem JS). */
(function () {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[id^="cbr-"]'));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('cbr-anim'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cbr-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // above-the-fold (hero / buy box) revela já no load, com leve stagger dos filhos diretos
    var top = document.querySelector('[id^="cbr-hero"], [id^="cbr-pdp"], [id^="cbr-models"]');
    if (top) {
      top.classList.add('cbr-in');
      var kids = top.querySelectorAll(':scope > *, :scope > * > *');
    }
    // failsafe: se algo travar, revela tudo depois de 2.2s
    setTimeout(function () { els.forEach(function (el) { el.classList.add('cbr-in'); }); }, 2200);
  } catch (e) { /* noop — conteúdo permanece visível */ }
})();
